<template lang="html">
<div class="layout-div__container clearfix">
  <div class="layout-div__title">
    <span class="layout-span__title__text">
      <i class="layout-i__line"></i>黑眼圈
    </span>
  </div>
  <div class="layout-div__body">
    <div class="result-div__legend clearfix">
      <div class="result-div__eyes">
        <img class="result-img" :src="darkCircle['vascular-img']" style="z-index: 9" />
        <img class="result-img" :src="darkCircle['pigmental-img']" style="z-index: 9" />
        <img class="result-img" :src="darkCircle['structural-img']" style="z-index: 9" />
        <img class="result-img" src="./imgs/report_blackeye_bg@2x.png" style="z-index:0;" alt="眼睛" />
      </div>
      <div class="result-div__des">
        <img class="result-img__desimg" src="./imgs/explain.jpg" alt="图例"/>
      </div>
    </div>
    <div class="result-div__circle" ref="circleWrapper">
      <canvas class="result-canvas__circle" ref="canvas0"></canvas>
      <canvas class="result-canvas__circle" ref="canvas1"></canvas>
      <canvas class="result-canvas__circle" ref="canvas2"></canvas>
    </div>
    <div class="result-div__degree">
      <h4 class="result-h4__degree__title">综合严重程度</h4>
      <div class="result-div__progress">
        <div class="light-green" ref="lightGreen"></div>
        <div class="green" ref="green"></div>
        <div class="red" ref="red"></div>
      </div>
      <span class="result-span__line"></span>
      <div class="result-div__tags">
        <span><i :class="this.degree.tag.light ? 'active' : ''">轻度</i></span>
        <span><i :class="this.degree.tag.green ? 'active' : ''">中度</i></span>
        <span><i :class="this.degree.tag.red ? 'active' : ''">重度</i></span>
      </div>
    </div>
  </div>
  <ul class="sr-ul__result__group clearfix">
    <li style="margin-top:5px;">
      {{advice}}
    </li>
  </ul>
</div>
</template>

<script>
/* eslint-disable */
import Circle from '@/lib/circle.js'
export default {
  beforeMount () {
    const {dark_circle, short_dark_circle_advice} = this.$store.state.result.resultData
    this.advice = short_dark_circle_advice
    this.darkCircle = Object.assign({}, dark_circle)
    for (let key in this.darkCircle) {
      if (key !== 'severity') {
        this.darkCircle[key] = parseInt(Math.ceil(this.darkCircle[key] * 10)) === 0 ? 1 : parseInt(Math.ceil(this.darkCircle[key] * 10)) 
        this.darkCircle[`${key}-img`] = require(`./imgs/report_blackeye_${key}${this.darkCircle[key]}@2x.png`)
      }
    }
    this.degreen = {
      severity: this.darkCircle.severity
    }
  },
  mounted () {
    const circleWrapper = this.$refs['circleWrapper']
    for (let i = 0, leng = 3; i < leng; i++) {
      this.$refs[`canvas${i}`].width = circleWrapper.offsetHeight * 2
      this.$refs[`canvas${i}`].height = circleWrapper.offsetHeight * 2
    }
    for (let key in this.darkCircle) {
      if (key !== 'sevrity') {
        if (this.darkCircle[key] <= 3) {
          this.darkCircle[`${key}Arr`] = [`${this.darkCircle[key]}级`, '轻度']
        } else if (this.darkCircle[key] > 3 && this.darkCircle[key] <= 7) {
          this.darkCircle[`${key}Arr`] = [`${this.darkCircle[key]}级`, '中度']
        } else {
          this.darkCircle[`${key}Arr`] = [`${this.darkCircle[key]}级`, '重度']
        }
      }
    }
    // 色素圆圈
    const circle0 = new Circle({
      color: '#c8a47f',
      element: this.$refs['canvas0'],
      ctx: this.$refs['canvas0'].getContext('2d'),
      lineWidth: 12,
      radius: circleWrapper.offsetHeight,
      text: this.darkCircle.pigmentalArr,
      percent: this.darkCircle.pigmental * 10
    })
    circle0.circleLauncher()
    // 血管圆圈
    const circle1 = new Circle({
      color: '#ae698c',
      element: this.$refs['canvas1'],
      ctx: this.$refs['canvas1'].getContext('2d'),
      lineWidth: 12,
      radius: circleWrapper.offsetHeight,
      text: this.darkCircle.vascularArr,
      percent: this.darkCircle.vascular * 10
    })
    circle1.circleLauncher()
    // 结构圆圈
    const circle2 = new Circle({
      color: '#646464',
      element: this.$refs['canvas2'],
      ctx: this.$refs['canvas2'].getContext('2d'),
      lineWidth: 12,
      radius: circleWrapper.offsetHeight,
      text: this.darkCircle.structuralArr,
      percent: this.darkCircle.structural * 10
    })
    circle2.circleLauncher()
    this.handleDegree()
  },
  methods: {
    handleDegree () {
      const lightGreen = this.$refs['lightGreen']
      const green = this.$refs['green']
      const red = this.$refs['red']
      this.degree.tag = {
        light: false,
        green: false,
        red: false
      }
      const {severity} = this.degreen
      if (Math.ceil(severity * 10) <= 3) {
        lightGreen.setAttribute('style', 'border-top-right-radius: 2.133333333vwborder-bottom-right-radius: 2.133333333vw;')
        lightGreen.style.width = `${severity * 24}vw`
        green.style.width = '0'
        red.style.width = '0'
        this.degree.tag.light = true
      } else if (Math.ceil(severity * 10) > 3 && Math.ceil(severity * 10) <= 7) {
        green.setAttribute('style', 'border-top-right-radius: 2.133333333vw;border-bottom-right-radius: 2.133333333vw;')
        green.style.width = `${(severity * 10 - 3) / 10 * 32}vw`
        red.style.width = '0'
        this.degree.tag.green = true
      } else {
        red.setAttribute('style', 'border-top-right-radius: 2.133333333vw;border-bottom-right-radius: 2.133333333vw;')
        red.style.width = `${(severity * 10 - 7) / 10 * 24}vw`
        this.degree.tag.red = true
      }
    }
  },
  data () {
    return {
      darkCircle: {},
      degree: {
        tag: {
          light: false,
          green: false,
          red: false
        }
      }
    }
  }
}
</script>

<style scoped>
.result-div__legend{
  margin-top: 8vw;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.result-div__eyes{
  width: 61.333333333vw;
  height: 28.108108108vw;
  margin-right: 8vw;
  position: relative;
}
.result-img{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
.result-div__des{
  width: 15.466666667vw;
}
.result-img__desimg{
  width: 100%;
}
.result-div__circle{
  margin-top: 9.333333333vw;
  display: flex;
  justify-content: center;
  align-content: center;
}
.result-canvas__circle{
  width: 17.333333333vw;
  height: 17.333333333vw;
  margin: 0 6.4vw;
}
.result-div__degree{
  margin-top: 10.666666667vw;
}
.result-h4__degree__title{
  margin: 0 auto;
  width: 80vw;
  font-size: 4.533333333vw;
}
.result-div__progress{
  margin: 0 auto;
  width: 80vw;
  margin-top: 8vw;
  background-color: #f0f0f0;
  border-radius: 2.133333333vw;
}
.result-div__progress::after{
  clear: both;
  display: table;
  content: '';
  visibility: hidden;
}
.result-span__line{
  display: block;
  margin: 0 auto;
  margin-top: 1.333333333vw;
  width: 80vw;
  border-bottom: 1px dashed #e3e3e3;
}
.light-green{
  width: 24vw;
  height: 2.666666667vw;
  background: #64c8c8;
  border-top-left-radius: 2.133333333vw;
  border-bottom-left-radius: 2.133333333vw;
  float: left;
}
.green{
  width: 32vw;
  height: 2.666666667vw;
  background: #32a0a0;
  float:left;
}
.red{
  width: 24vw;
  height: 2.666666667vw;
  background:#ff6e6e;
  float: left;
  border-top-right-radius: 2.133333333vw;
  border-bottom-right-radius: 2.133333333vw;
}
.result-div__tags{
  width: 80vw;
  margin: 0 auto;
  margin-top: 2.933333333vw;
}
.result-div__tags span{
  float: left;
  text-align: center;
  width: 26.666666667vw;
  font-size: 3.733333333vw;
}
.result-div__tags i {
  font-style: normal;
}
.active{
  border: 1px solid #64c8c8;
  color: #64c8c8;
  padding: 0 2.933333333vw;
  border-radius: 4.266666667vw;
  font-style: normal;
}
 .sr-ul__result__group {
    margin: 0;
    padding: 0;
    display: block;
    list-style: none;
    margin-top: 8vw;
    font-size: 15px;
  }
  .sr-ul__result__group li {
    font-family: 'PingFangSC';
  }
</style>



// WEBPACK FOOTER //
// src/components/Result/darkcircle.vue